import { Filters } from 'context/FilterProvider/types/Filters';
import { stateWriter } from 'features/Status/utils/statusWriter';

export const getOptionsForFilter = (filter: string, filterOptions: Filters) => {
  return filter === 'status'
    ? filterOptions.status.map(stateWriter)
    : filterOptions[filter as keyof Filters];
};
